module.exports = __webpack_public_path__ + "static/media/plus.dd64f2bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/plus.svg
// module id = 556
// module chunks = 0